import { produce } from 'immer';
import { localStorageFunc } from '../../utils/localStorage'
import * as Actions from '../actions/cartActions';
const initialState = {
  cartItems: [],
  totalAmount: 0,
};

const reducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case Actions.INITIALIZE_CART:
        draft.cartItems = action.payload
        draft.totalAmount = draft.cartItems.reduce((prev, cur) => {
          return prev.total + cur.total
        }, 0)
        break;
      case Actions.ADD_CART:
        draft.cartItems.push(action.payload);
        localStorageFunc('save', JSON.stringify(draft.cartItems), 'cart')
        break;
      case Actions.REMOVE_PRODUCT:
        const pId = action.payload;
        const productIndex = draft.cartItems.findIndex(
          (el) => el.id === pId
        );
        draft.cartItems.splice(productIndex, 1);
        localStorageFunc('save', JSON.stringify(draft.cartItems), 'cart')

        break;
      case Actions.INCREMENT:
        const productId = action.payload;
        draft.cartItems.find((el) => {
          if (el.id === productId) {
            el.noOfItems++;
            el.total += parseInt(el.price);
          }
        });
        localStorageFunc('save', JSON.stringify(draft.cartItems), 'cart')

        break;
      case Actions.DECREMENT:
        const cartProductId = action.payload;
        draft.cartItems.find((el) => {
          if (el.id === cartProductId && el.noOfItems > 1) {
            el.noOfItems--;
            el.total -= parseInt(el.price);
          }
        });
        localStorageFunc('save', JSON.stringify(draft.cartItems), 'cart')

        break;
      default:
        return state;
    }
  });

export default reducer;
